import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMessageSquare, FiCpu, FiSearch, FiStar } = FiIcons;

const Footer = ({ viewMode }) => {
  const prompt = "Tell me about Gary Fagerholm based on techguy.fun. Summarize who they are, what they do, and how to get in touch.";
  const encodedPrompt = encodeURIComponent(prompt);

  const aiProviders = [
    {
      name: 'ChatGPT',
      icon: FiMessageSquare,
      url: `https://chatgpt.com/?q=${encodedPrompt}`,
      hoverBg: 'hover:bg-[#10a37f]',
      borderColor: 'border-[#10a37f]',
      textColor: 'text-[#10a37f]',
    },
    {
      name: 'Claude',
      icon: FiCpu,
      url: `https://claude.ai/new?q=${encodedPrompt}`,
      hoverBg: 'hover:bg-[#d97757]',
      borderColor: 'border-[#d97757]',
      textColor: 'text-[#d97757]',
    },
    {
      name: 'Perplexity',
      icon: FiSearch,
      url: `https://www.perplexity.ai/?q=${encodedPrompt}`,
      hoverBg: 'hover:bg-[#20b8cd]',
      borderColor: 'border-[#20b8cd]',
      textColor: 'text-[#20b8cd]',
    },
    {
      name: 'Gemini',
      icon: FiStar,
      url: `https://gemini.google.com/app?q=${encodedPrompt}`,
      hoverBg: 'hover:bg-[#4285f4]',
      borderColor: 'border-[#4285f4]',
      textColor: 'text-[#4285f4]',
    }
  ];

  return (
    <footer className="bg-gray-50 border-t border-gray-200 py-16 relative z-10 w-full">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <motion.div 
            className="inline-flex items-center space-x-2 bg-purple-100 text-purple-700 px-4 py-2 rounded-full text-sm font-bold mb-6 shadow-sm"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <SafeIcon icon={FiCpu} className="w-4 h-4" />
            <span>AI Assistant</span>
          </motion.div>
          
          <motion.h2 
            className="font-heading text-3xl md:text-4xl font-bold text-gray-900 mb-4"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
          >
            Ask AI About Me
          </motion.h2>
          
          <motion.p 
            className="text-xl text-gray-600 mb-10 leading-relaxed"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
          >
            Curious to learn more? Choose your favorite AI assistant to get a quick summary of my background, skills, and how we can connect.
          </motion.p>
          
          <motion.div 
            className="flex flex-wrap justify-center gap-4"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.3 }}
          >
            {aiProviders.map((ai) => (
              <motion.a
                key={ai.name}
                href={ai.url}
                target="_blank"
                rel="noopener noreferrer"
                className={`flex items-center px-6 py-3 rounded-xl border-2 font-bold bg-white transition-all duration-300 ${ai.borderColor} ${ai.textColor} ${ai.hoverBg} hover:text-white shadow-sm hover:shadow-md`}
                whileHover={{ scale: 1.05, y: -2 }}
                whileTap={{ scale: 0.95 }}
              >
                <SafeIcon icon={ai.icon} className="w-5 h-5 mr-2" />
                Ask {ai.name}
              </motion.a>
            ))}
          </motion.div>
        </div>
        
        <div className="mt-16 pt-8 border-t border-gray-200 text-center text-gray-500 flex flex-col md:flex-row justify-between items-center">
          <p className="font-medium text-sm mb-4 md:mb-0">
            © {new Date().getFullYear()} Gary Fagerholm. All rights reserved.
          </p>
          <div className="flex space-x-4 text-sm font-medium">
            <span>Made with React & Tailwind</span>
            <span>•</span>
            <span>Powered by AI</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;